export var HOUSE_RULES_GROUP;
(function (HOUSE_RULES_GROUP) {
  HOUSE_RULES_GROUP["CHILDREN_ALLOWED"] = "children_allowed";
  HOUSE_RULES_GROUP["EVENTS_ALLOWED"] = "events_allowed";
  HOUSE_RULES_GROUP["PETS_ALLOWED"] = "pets_allowed";
  HOUSE_RULES_GROUP["SMOKING_ALLOWED"] = "smoking_allowed";
})(HOUSE_RULES_GROUP || (HOUSE_RULES_GROUP = {}));